"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.react-utils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ColGrid = function ColGrid(_ref) {
  var children = _ref.children,
      mobileCols = _ref.mobileCols,
      desktopCols = _ref.desktopCols,
      visibleMobile = _ref.visibleMobile,
      hideMobile = _ref.hideMobile;
  var childOfSpecificTag = (0, _gerenciatdUtils.noOneChildOfSpecificTag)('ColGrid', children);

  if (!childOfSpecificTag) {
    console.warn("No one child of ColGrid can be a ColGrid component");
    return null;
  }

  var colClass = "padding0 col-xs-".concat(mobileCols);

  if (desktopCols) {
    colClass = "".concat(colClass, " col-sm-").concat(desktopCols);
  }

  if (visibleMobile) {
    colClass = "".concat(colClass, " visible-xs");
  }

  if (hideMobile) {
    colClass = "".concat(colClass, " hide-xs");
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: colClass,
    children: children
  });
};
/*  Proptypes for the Card props */


ColGrid.propTypes = {
  children: _propTypes["default"].node.isRequired,
  mobileCols: _propTypes["default"].number.isRequired,
  desktopCols: _propTypes["default"].number,
  visibleMobile: _propTypes["default"].bool,
  hideMobile: _propTypes["default"].bool
};
/* Default values for non required props */

ColGrid.defaultProps = {
  desktopCols: 0,
  visibleMobile: false,
  hideMobile: false
};
var _default = ColGrid;
exports["default"] = _default;

//# sourceMappingURL=index.js.map